import React from 'react';
import { numPad, plural } from '../../Services/helpers';
import NoValue from '../EmptyStates/NoValue';

const Duration = ({ time, empty, sum, onClick, before, after, className, short, hideSeconds }) => {
    let theTime = time;

    if (sum) {
        theTime = doSum(sum);
    }

    if (!theTime || theTime === '00:00:00') {
        return empty ?? <NoValue />;
    }

    const parts = theTime.split(':');
    const hours = parseInt(parts[0]);
    const minutes = parseInt(parts[1]);
    const seconds = parseInt(parts[2]);

    return <span className={className} onClick={() => onClick && onClick(theTime)}>
        {before && before}
        {hours > 0 && <span>{hours}{short ? 'h' : plural(hours, '', ' hour', ' hours')}</span>}
        {(hours > 0 && minutes > 0) && <span> </span>}
        {minutes > 0 && <span>{minutes}{short ? 'm' : plural(minutes, '', ' minute', ' minutes')}</span>}
        {(minutes > 0 && seconds > 0) && <span> </span>}
        {(seconds > 0 && !hideSeconds) && <span>{seconds}{short ? 's' : plural(seconds, '', ' second', ' seconds')}</span>}
        {after && after}
    </span>
}

const doSum = (durations) => {
    if (!durations || durations.length === 0) {
        return null;
    }

    let totalSeconds = 0;

    for (const duration of durations) {
        const parts = duration.split(':');
        const hours = parseInt(parts[0]);
        const minutes = parseInt(parts[1]);
        const seconds = parseInt(parts[2]);

        totalSeconds += (hours * 3600) + (minutes * 60) + seconds;
    }

    const hours = numPad(Math.floor(totalSeconds / 3600));
    const minutes = numPad(Math.floor((totalSeconds - (hours * 3600)) / 60));
    const seconds = numPad(totalSeconds - (hours * 3600) - (minutes * 60));

    return `${hours}:${minutes}:${seconds}`;
}

export default Duration;
